<template>
  <v-card class="tab-card bg-dot-img">
    <v-tabs
      v-model="tab"
    >
     <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" class="tabs-box" >
          Residential Real Estate
      </v-tab>

      <v-tab href="#tab-2" class="tabs-box">
          Commercial Real Estate
      </v-tab>

      <v-tab href="#tab-3" class="tabs-box">
          Industrial Real Estate

      </v-tab>

      <v-tab href="#tab-4" class="tabs-box" >
         Land Estate
      </v-tab>

      <v-tab href="#tab-5" class="tabs-box">
        REIT
      </v-tab>

      <v-tab href="#tab-6" class="tabs-box">
        InvIT
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item value="tab-1">
        <ResidentialRealState />
      </v-tab-item>

      <v-tab-item value="tab-2">
        <CommercialRealState />
      </v-tab-item>

      <v-tab-item value="tab-3" >
        <IndustrialRealState />
      </v-tab-item>

      <v-tab-item value="tab-4">
        <LandState />
      </v-tab-item>

      <v-tab-item value="tab-5">
        <RealStateInvestmentTrust />
      </v-tab-item>

      <v-tab-item value="tab-6">
        <InfrasturctureInvestmentTrust />
      </v-tab-item>
      
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

  import CommercialRealState from './CommercialRealState/ListCommercialRealState.vue'; 
  import IndustrialRealState from './IndustrialRealState/ListIndustrialRealState.vue';
  import LandState from './LandState/ListLandState.vue'; 
  import RealStateInvestmentTrust from './RealStateInvestmentTrust/ListRealStateInvestmentTrust.vue';
  import ResidentialRealState from './ResidentialRealState/ListResidentialRealState.vue';
  import InfrasturctureInvestmentTrust from './InfrasturctureInvestmentTrust/ListInfraInvestmentTrust.vue';
   
  export default {
    components: {
      CommercialRealState,
      IndustrialRealState,
      LandState,
      RealStateInvestmentTrust,
      ResidentialRealState,
      InfrasturctureInvestmentTrust,
    },
    data () {
      return {
        tab: this.$route.params.tab,
        text: '',
        tabName: '',
      }
    },
    beforeCreate(){
    },
    methods:{
      CheckTab(tabName)
      {
        //this.tabName = tabName;;
      }
    },
  }
</script>